//分页状态
export const loadingType = {
  LOADING: "loading",
  FINISHED: "finished",
  ERROR: "error",
  EMPTY: "empty",
};

export const INDUSTRY_MODEL = {
  LABEL: "label",
  MODE: "mode",
};

export const OCR_TYPE = {
  ID_CARD: "0",
  BANK_CARD: "1",
  BUSINESS_CARD: "2",
};

export const IMG_OPTION = {
  MAX_SIZE: 1048000,
  COMPRESS_MAX_COUNT: 5,
};

export const ROUTER = {
  MAIN: "/", //首页
  LOGIN: "/login", //登录
  REGISTER: "/register", //注册
  REGISTER2: "/register_fz", //服装注册
  OPEN_PAYMENT: "/open_payment", //注册引导页
  AGREEMENT: "/agreement", //协议
  HELPER: "/business_instructions", //操作说明
  BUSINESS_INFO_1: "/business_Identity_01", //经营信息
  BUSINESS_INFO_2: "/business_Identity_02", //身份资料
  BUSINESS_INFO_3: "/business_Identity_03", //收款卡信息
  BUSINESS_INFO_4: "/business_Identity_04", //营业执照信息
  AUTHORIZATION: "/pay_authorization", //营业执照信息
  WX_AUDIT: "/pay_audit", //微信审核
  A_LI_AUDIT: "/pay_audit_ali", //支付宝审核
};

export const ROUTER_V1 = {
  MAIN: "/",
  REGISTER: "/register_v1", //注册
};
